import { createContext, useContext } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useState } from "react";
import { useImmer } from "use-immer";
const snackbarContext = createContext(null);

export const useSnackBarContext = () => useContext(snackbarContext);

//provider for snackbar

export const SnackbarWrapper = ({ children }) => {
  const [state, updateState] = useImmer({
    open: false,
    message: "",
    isError: false,
  });

  const handleClose = (event, reason) => {
    updateState((draft) => {
      draft.open = false;
    });
  };
  const showToast = ({ message, error = false }) => {
    updateState((draft) => {
      draft.open = true;
      draft.message = message;
      draft.isError = error;
    });
  };

  return (
    <snackbarContext.Provider value={{ showToast }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={state.open}
        onClose={handleClose}
        autoHideDuration={3000}
      >
        <Alert
          onClose={handleClose}
          severity={state.isError ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%", color: "white" }}
        >
          {state.message}
        </Alert>
      </Snackbar>
      {children}
    </snackbarContext.Provider>
  );
};
